import script from "./PriceAlertsModal.vue?vue&type=script&setup=true&lang=js"
export * from "./PriceAlertsModal.vue?vue&type=script&setup=true&lang=js"

import "./PriceAlertsModal.vue?vue&type=style&index=0&id=267c94d6&lang=scss"

const __exports__ = script;

export default __exports__